
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-engine/blog",
      function () {
        return require("private-next-pages/talent-engine/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talent-engine/blog"])
      });
    }
  